import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Settings } from 'lucide-react';
import { ProjectsContainer } from '../dashboard/projects/ProjectsContainer';

interface ProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ProjectModal({ isOpen, onClose }: ProjectModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-7xl w-[95vw] h-[95vh] p-0 gap-0 rounded-2xl border-slate-200/60 shadow-2xl">
        {/* Enhanced Header with Apple-like design */}
        <DialogHeader className="flex flex-row items-center justify-between p-6 border-b border-slate-200/60 bg-gradient-to-r from-slate-50/80 via-white to-slate-50/80 backdrop-blur-sm rounded-t-2xl">
          <div className="flex items-center gap-4">
            <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center shadow-lg shadow-slate-900/20">
              <Settings className="w-5 h-5 text-white" />
            </div>
            <div>
              <DialogTitle className="text-xl font-bold text-slate-900 tracking-tight">
                Project Management
              </DialogTitle>
              <DialogDescription className="text-sm text-slate-600 font-medium mt-0.5">
                Create, manage, and track your hiring projects
              </DialogDescription>
            </div>
          </div>
          
          <DialogClose asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-9 w-9 p-0 rounded-lg hover:bg-slate-100/80 text-slate-600 hover:text-slate-900 transition-all duration-200"
            >
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </Button>
          </DialogClose>
        </DialogHeader>
        
        {/* Content Area with improved scrolling */}
        <div className="flex-1 overflow-hidden rounded-b-2xl">
          <div className="h-full overflow-y-auto bg-gradient-to-br from-slate-50/30 via-white to-slate-50/50">
            <div className="min-h-full">
              <ProjectsContainer />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
} 